// /discord/linked —— Discord 綁定導回頁（對方服務 OAuth 完成後 302 回此頁，帶 status/ref/discordId/discordUsername）
// 私有路由（需登入）：讀 query → 呼叫 /api/discord/link-callback 存 discordId（後端會核對 ref 屬本人）。
import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axiosInstance from "api/axiosInstance";
import { LanguageContext } from "context/LanguageContext";
import { COLORS } from "theme/tokens";

export default function DiscordLinked() {
  const navigate = useNavigate();
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const [state, setState] = useState("processing"); // processing | success | error
  const [username, setUsername] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    loadLanguageFile("DiscordLinked", "discord/DiscordLinked/DiscordLinked_lang");
  }, [language, loadLanguageFile]);
  const L = (componentLanguageData.DiscordLinked || { Main: {} }).Main || {};

  useEffect(() => {
    if (ran.current) return; // 一次性：避免 StrictMode 重跑害 ref 被消耗兩次
    ran.current = true;
    const p = new URLSearchParams(window.location.search);
    const status = p.get("status");
    const ref = p.get("ref");
    const discordId = p.get("discordId");
    const discordUsername = p.get("discordUsername") || "";
    if (status !== "success" || !ref || !discordId) {
      setState("error");
      return;
    }
    axiosInstance
      .post("/discord/link-callback", { ref, discordId, discordUsername })
      .then((res) => {
        setUsername(res.data?.discordUsername || discordUsername);
        setState("success");
      })
      .catch(() => setState("error"));
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="70vh" px={2}>
        <Card sx={{ maxWidth: 460, width: "100%", p: 4, borderRadius: 3, textAlign: "center", boxShadow: 1 }}>
          {state === "processing" && (
            <>
              <CircularProgress color="info" sx={{ mb: 2 }} />
              <MDTypography variant="h6">{L.Processing || "正在綁定 Discord…"}</MDTypography>
            </>
          )}

          {state === "success" && (
            <>
              <MDTypography variant="h4" sx={{ color: COLORS.success || "#4CAF50", mb: 1 }}>✅</MDTypography>
              <MDTypography variant="h5" fontWeight="bold" mb={1}>
                {L.SuccessTitle || "Discord 綁定成功"}
              </MDTypography>
              {username ? (
                <MDTypography variant="body2" color="text" mb={1}>
                  {(L.LinkedAs || "已連結：")}<b>{username}</b>
                </MDTypography>
              ) : null}
              <MDTypography variant="body2" color="text" mb={3}>
                {L.SuccessDesc || "你的帳號已連結 Discord。若為付費會員，VIP 身分組將自動發放（可能需稍候）。"}
              </MDTypography>
              <MDButton variant="gradient" color="info" onClick={() => navigate("/profile/discord")}>
                {L.BackBtn || "返回個人資料"}
              </MDButton>
            </>
          )}

          {state === "error" && (
            <>
              <MDTypography variant="h4" sx={{ color: COLORS.error || "#F44335", mb: 1 }}>⚠️</MDTypography>
              <MDTypography variant="h5" fontWeight="bold" mb={1}>
                {L.ErrorTitle || "綁定失敗"}
              </MDTypography>
              <MDTypography variant="body2" color="text" mb={3}>
                {L.ErrorDesc || "Discord 綁定未完成，請回到個人資料重試。"}
              </MDTypography>
              <MDButton variant="gradient" color="info" onClick={() => navigate("/profile/discord")}>
                {L.BackBtn || "返回個人資料"}
              </MDButton>
            </>
          )}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
